import { AuthorizationConfig } from 'core/auth/authorization.config'
import {
  Center,
  City,
  Country,
  DeviceActivation,
  Folder,
  Infraction,
  AccessorInfraction,
  Interactive,
  Lesson,
  Question,
  LessonQuiz,
  LessonText,
  Program,
  Session,
  Skill,
  StartExamConfig,
  StaticScreen,
  User,
  Video,
  Audio,
  Speech,
  Interview,
  OnlineSession,
  Hub,
  HubRegistration,
  Briefing,
  Notification,
  CancellationReason,
  CurrentUser
} from 'models'

export var authorizationConfig: AuthorizationConfig

authorizationConfig = new AuthorizationConfig({
  policies: {
    AppPackage: {
      index: function(user: User): boolean {
        return user.isAdmin()
      },

      create: function(user: User): boolean {
        return user.isAdmin()
      },

      edit: function(user: User, center: Center): boolean {
        return user.isAdmin()
      },

      destroy: function(user: User, center: Center): boolean {
        return user.isAdmin()
      }
    },

    Briefing: {
      create(user: User): boolean {
        return user.isAdmin() || user.isContentEditor() ||
        user.can(['manage:all', 'manage:briefings', 'briefing:create'])
      },
      edit(user: User, briefing: Briefing): boolean {
        return user.isAdmin() || user.isContentEditor() ||
        user.can(['manage:all', 'manage:briefings', 'briefing:update'])
      },
      index(user: User): boolean {
        return user.isAdmin() || user.isContentEditor() ||
        user.can(['manage:all', 'manage:briefings', 'briefing:index'])
      }
    },

    PhoneControl: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:phone_control', 'phone_control:index'])
      },

      create(user: User): boolean {
        return user.isAdmin() || user.isPhoneController() ||
          user.can(['manage:phone_control', 'phone_control:create'])
      }
    },

    CancellationReason: {
      index: function(user: User): boolean {
        return user.isAdmin()
      },

      create: function(user: User): boolean {
        return user.isAdmin()
      },

      edit: function(user: User, cancellationReason: CancellationReason): boolean {
        return user.isAdmin()
      },

      destroy: function(user: User, cancellationReason: CancellationReason): boolean {
        return user.isAdmin()
      },

      disable: function(user: User, cancellationReason: CancellationReason): boolean {
        return user.isAdmin()
      },

      restore: function(user: User, cancellationReason: CancellationReason): boolean {
        return user.isAdmin()
      }
    },

    Center: {
      index(user: User): boolean {
        return user.isAdmin() || user.isContentEditor() ||
          user.can(['manage:centers', 'centers:index'])
      },

      create(user: User): boolean {
        return user.isAdmin() || user.isContentEditor() ||
          user.can(['manage:centers', 'centers:create'])
      },

      edit(user: User, center: Center): boolean {
        return user.isAdmin() || user.isContentEditor() ||
          user.can(['manage:centers', 'centers:update'])
      },

      destroy(user: User, center: Center): boolean {
        return user.isAdmin() || user.isContentEditor() ||
          user.can(['manage:centers', 'centers:destroy'])
      },

      disable(user: User, center: Center): boolean {
        return user.isAdmin() || user.isContentEditor() ||
          user.can(['manage:centers', 'centers:disable'])
      },

      restore(user: User, center: Center): boolean {
        return user.isAdmin() || user.isContentEditor() ||
          user.can(['manage:centers', 'centers:restore'])
      }
    },

    City: {
      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, city: City): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, city: City): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, city: City): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, city: City): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    Country: {
      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, country: Country): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, country: Country): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, country: Country): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, country: Country): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    DeviceActivation: {
      index: function(user: User): boolean {
        return user.isAdmin()
      }
    },

    ApiKey: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:api_keys', 'api_keys:index'])
      },
      create(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:api_keys', 'api_keys:create'])
      },
      change(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:api_keys', 'api_keys:change'])
      },
    },

    Folder: {
      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, folder: Folder): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, folder: Folder): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    Infraction: {
      index: function(user: User): boolean {
        return user.isAdmin()
      },

      create: function(user: User): boolean {
        return user.isAdmin()
      },

      edit: function(user: User, infraction: Infraction): boolean {
        return user.isAdmin()
      },

      destroy: function(user: User, infraction: Infraction): boolean {
        return user.isAdmin()
      },

      disable: function(user: User, infraction: Infraction): boolean {
        return user.isAdmin()
      },

      restore: function(user: User, infraction: Infraction): boolean {
        return user.isAdmin()
      }
    },

     AccessorInfraction: {
      index: function(user: User): boolean {
        return user.isAdmin()
      },

      create: function(user: User): boolean {
        return user.isAdmin()
      },

      edit: function(user: User, infraction: AccessorInfraction): boolean {
        return user.isAdmin()
      },

      destroy: function(user: User, infraction: AccessorInfraction): boolean {
        return user.isAdmin()
      },

      disable: function(user: User, infraction: AccessorInfraction): boolean {
        return user.isAdmin()
      },

      restore: function(user: User, infraction: AccessorInfraction): boolean {
        return user.isAdmin()
      }
    },

    Interactive: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, interactive: Interactive): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, interactive: Interactive): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, interactive: Interactive): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, interactive: Interactive): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    Lesson: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, lesson: Lesson): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, lesson: Lesson): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, lesson: Lesson): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, lesson: Lesson): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    LessonQuestion: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, question: Question): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, question: Question): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, question: Question): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, question: Question): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    LessonQuiz: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, lessonQuiz: LessonQuiz): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, lessonQuiz: LessonQuiz): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, lessonQuiz: LessonQuiz): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, lessonQuiz: LessonQuiz): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    LessonText: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, lessonText: LessonText): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, lessonText: LessonText): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, lessonText: LessonText): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, lessonText: LessonText): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    LessonVideo: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, video: Video): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, video: Video): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, video: Video): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, video: Video): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    Speech: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, speech: Speech): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, speech: Speech): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, speech: Speech): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, speech: Speech): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    Audio: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, audio: Audio): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, audio: Audio): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, audio: Audio): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, audio: Audio): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    Program: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, program: Program): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, program: Program): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, program: Program): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, program: Program): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },
    
    // sessions:index_xlsx
    Session: {
      index(user: User): boolean {
        return user.isAdmin() || user.isAccessor() || user.isCenterMember() ||
          user.isVideoAccessor() || user.isModerator() || user.isInterviewer() ||
          user.isSupport() || user.can(['manage:sessions'])
      },

      statistics(u: User): boolean {
        return u.isAdmin() || u.isModerator() || u.isInterviewer()
          || u.can(['repotrs:all', 'manage:sessions'])
      },

      onlineStatistics(u: User): boolean {
        return u.isAdmin() || u.isOnlineInterviewer() || u.isModerator()
          || u.can(['repotrs:all', 'manage:sessions'])
      },

      indexXlsx(u: User): boolean {
        return u.can(['sessions:index_xlsx'])
      },

      show: function(user: User, session: Session): boolean {
        return user.isAdmin() || user.isAccessor() || user.isCenterMember() ||
          user.isInterviewer() || user.isModerator() || user.isSupport() ||
          user.can(['manage:sessions'])
      },

      edit(u: User, s: Session): boolean {
        return u.isAdmin() || (u.isAccessor() && this.accessorComplete(u, s))
          || u.isModerator() || u.can(['manage:sessions', 'sessions:edit_driver'])
      },

      accessorComplete(u: User, s: Session): boolean {
        return u.isAccessor() && s.isCompleted() && s.isAccessorStarted() && (s.accessorId == u.id)
      },

      adminComplete(u: User, s: Session): boolean {
        return u.isAdmin()
      },

      moderatorComplete(u: User, s: Session): boolean {
        return u.isModerator()
      },

      indexControlPhotos(u: User, s: Session): boolean {
        return u.isAdmin() || u.isAccessor() || u.isModerator()|| u.can(['manage:sessions'])
      },

      showVideoAccessorResolution(u: User, s: Session): boolean {
        return u.isAdmin() || u.isModerator()|| u.can(['manage:sessions'])
      },

      showModerationComponent(u: User, s: Session): boolean {
        return u.isAdmin() || u.isModerator() || u.can(['manage:sessions'])
      },

      showInterviewerResolution(u: User, s: Session): boolean {
        return !u.isCenterMember() ||
          u.can(['manage:sessions', 'sessions:show_interviewer_resolution'])
      },

      showAccessorResolution(u: User, s: Session): boolean {
        return u.isAdmin() || u.isModerator() || u.isAccessor()||
          u.can(['manage:sessions', 'sessions:show_acessor_resolution'])
      },

      accessResolution (u: User, s: Session): boolean {
        return this.accessorComplete(u, s) || this.adminComplete(u, s) || u.isModerator()
          || u.can(['manage:sessions'])
      },

      showSessionExamReport (u: User, s: Session): boolean {
        return u.isAdmin() || u.isAccessor() || u.isModerator() || u.isInterviewer() ||
          u.isCenterMember()|| u.can(['manage:sessions'])
      },

      showSessionHistory (u: User, s: Session): boolean {
        return u.isAdmin() || u.isAccessor() || u.isModerator() || u.isInterviewer()
          || u.can(['manage:sessions'])
      }
    },

    Setting: {
      index: function(user: User): boolean {
        return user.isAdmin()
      },

      edit: function(user: User): boolean {
        return user.isAdmin()
      }
    },

    Skill: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    StartExamConfig: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, startExamConfig: StartExamConfig): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, startExamConfig: StartExamConfig): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, startExamConfig: StartExamConfig): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, startExamConfig: StartExamConfig): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    StaticScreen: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, staticScreen: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, staticScreen: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, staticScreen: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, staticScreen: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    User: {
      index(user: User): boolean {
        return user.can(['manage:users', 'users:index'])
      },

      create(user: User): boolean {
        return user.can(['manage:users', 'users:create'])
      },

      edit(user: User, targetUser: User): boolean {
        return user.can(['manage:users', 'users:update'])
      },

      disable(user: User, targetUser: User): boolean {
        return user.can(['manage:users', 'users:disable'])
      },

      destroy(user: User, targetUser: User): boolean {
        return user.can(['manage:users', 'users:destroy'])
      },

      restore(user: User, targetUser: User): boolean {
        return user.can(['manage:users', 'users:restore'])
      },

      managePermissions(u: User, targetU: User): boolean {
        return u.can(['manage:users', 'users:manage_permissions'])
      }
    },

    AppLocale: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      show: function(user: User, appLocale: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, appLocale: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, appLocale: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    AppTranslation: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      show: function(user: User, appLocale: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, appLocale: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, appLocale: StaticScreen): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    DriverSession: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isAccessor() || user.isCenterMember()
      },

      show: function(user: User, session: Session): boolean {
        return user.isAdmin() || user.isAccessor() || user.isCenterMember()
      },
    },

    Exam: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    Section: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, skill: Skill): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    ExamRegistration: {
      index(user: User): boolean {
        return user.isAdmin() || user.isSupport() ||
          user.can(['manage:exam_registrations', 'exam_registrations:index'])
      },

      create(user: User): boolean {
        return user.isAdmin() || user.isSupport() ||
          user.can(['manage:exam_registrations', 'exam_registrations:create'])
      },
    },

    Interview: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      edit: function(user: User, interview: Interview): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      destroy: function(user: User, interview: Interview): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      disable: function(user: User, interview: Interview): boolean {
        return user.isAdmin() || user.isContentEditor()
      },

      restore: function(user: User, interview: Interview): boolean {
        return user.isAdmin() || user.isContentEditor()
      }
    },

    OnlineSession: {
      index: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() ||
          user.isCenterMember() ||
          user.isSupport() ||
          user.isOnlineInterviewer() ||
          user.can(['web_sessions:resolution'])
      },

      indexXlsx: function(user: User): boolean {
        return user.can(['sessions:index_xlsx'])
      },

      show: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() || user.isOnlineInterviewer() || user.isCenterMember() || user.isSupport()
      },

      cancel: function(user: User, session: OnlineSession): boolean {
        /**
         * пользователь админ или
         * плользователь онлайн-интервьюер или пльзователь может принимать / отклонять сессии +
         * пользователь интервьюер этой сессии + сессия не завершена
         */
        const admin = user.isAdmin()
        const interviewer = user.isOnlineInterviewer() && session.interviewerId == user.id
        const permission = user.can(['web_sessions:resolution'])
        return !session.isCancelled && 
        ( admin || 
          ((interviewer || permission) && !session.isCompleted)
        )
      },
      /**
       * пользователь админ или
       * плользователь онлайн-интервьюер или пльзователь может принимать / отклонять сессии +
       * пользователь интервьюер этой сессии + сессия не завершена
       */
      accept: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() || (
          (user.isOnlineInterviewer() || user.can(['web_sessions:resolution'])) &&
          session.interviewerId == user.id &&
          !session.isCompleted
        )
      },

      moveInterviewRegistration: function(user: User, session: OnlineSession): boolean {
        return session.interviewMovable && (
          user.isAdmin() || 
          (user.isOnlineInterviewer() && session.interviewerId == user.id) || 
          user.can(["interview_registrations:manage_all"])
        )
      },

      createCommemt: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() || user.isOnlineInterviewer()
      },

      createAttachment: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() || user.isOnlineInterviewer()
      },

      showComments: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() || user.isOnlineInterviewer() ||
          user.can(['manage:web_sessions', 'web_sessions:show_comments'])
      },

      showInterview: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() || user.isOnlineInterviewer()
      },

      cancelInterview: function(user: User, session: OnlineSession): boolean {
        return session.hasInterviewRegistration && (user.isAdmin() || (
          (user.isOnlineInterviewer() || user.can(['web_sessions:resolution'])) &&
          session.interviewerId == user.id &&
          !session.isCompleted
        ))
      },

      cancelBriefing: function(user: User, session: OnlineSession): boolean {
        return session.hasBriefingRegistration && (user.isAdmin() || (
          user.can(['web_sessions:cancel_briefing', 'web_sessions:resolution']) && !session.isCompleted
        ))
      },

      showExamReport: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() || user.isOnlineInterviewer() || user.isCenterMember()
      },
      
      manageInterviewRegistrations: (user: User, session: OnlineSession): boolean => {
        return user.can(["interview_registrations:manage_all"])
      },

      assignSelf: (user: User, session: OnlineSession) => {
        return user.isOnlineInterviewer() && user.id != session.interviewerId
      }
    },

    HubModerationSession: {
      index: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() ||
          user.can(['manage:hub_moderation_sessions', 'hub_moderation_sessions:show'])
      },

      show: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() ||
          user.can(['manage:hub_moderation_sessions', 'hub_moderation_sessions:show'])
      },

      moderate: function(user: User, session: OnlineSession): boolean {
        return user.isAdmin() ||
          (
            !session.isFinished &&
            user.can(['manage:hub_moderation_sessions', 'hub_moderation_sessions:moderate'])
          ) ||
          (
            session.interviewInProcess &&
            user.can(['manage:hub_moderation_sessions', 'hub_moderation_sessions:moderate']) &&
            this.session.interviewerId == this.currentUser().id
          )
      },
    },

    Hub: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isHubCoordinator()
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isHubCoordinator()
      },

      edit: function(user: User, hub: Hub): boolean {
        return user.isAdmin() || user.isHubCoordinator()
      }
    },

    HubRegistration: {
      index: function(user: User): boolean {
        return user.isAdmin() || user.isCenterMember() ||
          user.can(['manage:exam_registrations', 'exam_registrations:index'])
      },

      indexXlsx(user: User): boolean {
        return user.can(['sessions:index_xlsx'])
      },

      create: function(user: User): boolean {
        return user.isAdmin() || user.isCenterMember() ||
          user.can(['manage:exam_registrations'])
      },

      edit: function(user: User, hubRegistration: HubRegistration): boolean {
        return user.isAdmin() || user.isCenterMember() ||
          user.can(['manage:exam_registrations'])
      },
      
      delete: function(user: User, hubRegistration: HubRegistration): boolean {
        return user.isAdmin() || user.isCenterMember() ||
          user.can(['manage:exam_registrations'])
      }
    },

    ABTests: {
      index(user: User): boolean {
        return user.isAdmin()
      }
    },

    ExportResult: {
      index(user: User): boolean {
        return user.isAdmin() || user.isCenterMember() || user.isSupport() ||
          user.isInterviewer() || user.isOnlineInterviewer() ||
          user.can(['manage:export_results', 'export_results:index'])
      }
    },

    ABExperiments: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:ab_experiments', 'ab_experiments:index'])
      },

      update(user: User) :boolean {
        return user.isAdmin() ||
          user.can(['manage:ab_experiments', 'ab_experiments:update'])
      },

      create(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:ab_experiments', 'ab_experiments:create'])
      },

      showResults(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:ab_experiments', 'ab_experiments:show_results'])
      },

      stop(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:ab_experiments', 'ab_experiments:update'])
      },

      start(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:ab_experiments', 'ab_experiments:update'])
      }
    },

    OnlineInterviewerSchedules: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:online_interviewer_schedules', 'online_interviewer_schedules:show'])
      },

      show(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:online_interviewer_schedules', 'online_interviewer_schedules:show'])
      },

      create(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:online_interviewer_schedules', 'online_interviewer_schedules:create'])
      },

      update(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:online_interviewer_schedules', 'online_interviewer_schedules:update'])
      },

      destroy(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:online_interviewer_schedules', 'online_interviewer_schedules:destroy'])
      }
    },

    Report: {
      show(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:reports', 'reports:show'])
      },

      create(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:reports', 'reports:create'])
      },

      download(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:reports', 'reports:download'])
      }
    },

    SmsTemplates: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:sms_templates', 'sms_templates:show'])
      },
      show(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:sms_templates', 'sms_templates:show'])
      },
      edit(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:sms_templates', 'sms_templates:edit'])
      },
      create(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:sms_templates', 'sms_templates:create'])
      },
      update(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:sms_templates', 'sms_templates:update'])
      },
      disable(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:sms_templates', 'sms_templates:disable'])
      },
      restore(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:sms_templates', 'sms_templates:restore'])
      },
      destroy(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:sms_templates', 'sms_templates:destroy'])
      }
    },

    Notification: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.isPhoneController() || user.isOnlineInterviewer()
      }
    },

    PifiaReviews: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:pifia_reviews', 'pifia_reviews:show'])
      },
      show(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:pifia_reviews', 'pifia_reviews:show'])
      },
      edit(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:pifia_reviews', 'pifia_reviews:edit'])
      },
      create(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:pifia_reviews', 'pifia_reviews:create'])
      },
      update(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:pifia_reviews', 'pifia_reviews:update'])
      },
      disable(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:pifia_reviews', 'pifia_reviews:disable'])
      },
      restore(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:pifia_reviews', 'pifia_reviews:restore'])
      },
      destroy(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:pifia_reviews', 'pifia_reviews:destroy'])
      }
    },

    ProgramGroups: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:program_groups', 'program_groups:show'])
      },
      show(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:program_groups', 'program_groups:show'])
      },
      edit(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:program_groups', 'program_groups:edit'])
      },
      create(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:program_groups', 'program_groups:create'])
      },
      update(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:program_groups', 'program_groups:update'])
      },
      destroy(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:program_groups', 'program_groups:destroy'])
      }
    },

    PersonalCabinet: {
      index(user: User): boolean {
        return true
      },
      show(user: User): boolean {
        return user.id == this.currentUser().id
      },
      edit(user: User): boolean {
        return user.id == this.currentUser().id
      },
      update(user: User): boolean {
        return user.id == this.currentUser().id
      }
    },

    Sidekiq: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:sidekiq', 'sidekiq:show'])
      }
    },

    TariffGroups: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:tariff_groups', 'tariff_groups:show'])
      },
      show(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:tariff_groups', 'tariff_groups:show'])
      },
      edit(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:tariff_groups', 'tariff_groups:edit'])
      },
      create(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:tariff_groups', 'tariff_groups:create'])
      },
      update(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:tariff_groups', 'tariff_groups:update'])
      },
      destroy(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:tariff_groups', 'tariff_groups:destroy'])
      }
    },

    Tariffs: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:tariffs', 'tariffs:show'])
      },
      show(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:tariffs', 'tariffs:show'])
      }
    },

    InterviewerGroups: {
      index(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:interviewer_groups', 'interviewer_groups:show'])
      },
      show(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:interviewer_groups', 'interviewer_groups:show'])
      },
      edit(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:interviewer_groups', 'interviewer_groups:update'])
      },
      create(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:interviewer_groups', 'interviewer_groups:create'])
      },
      destroy(user: User): boolean {
        return user.isAdmin() ||
          user.can(['manage:interviewer_groups', 'interviewer_groups:destroy'])
      }
    }

  },
})



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/config/authorization.config.ts